import { useEffect, type ReactNode } from "react";

interface SheetProps {
  open: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
}

export default function Sheet({ open, onClose, title, children }: SheetProps) {
  useEffect(() => {
    if (open) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "";
    }
    return () => {
      document.body.style.overflow = "";
    };
  }, [open]);

  if (!open) return null;

  return (
    <div className="fixed inset-0 z-50 flex items-end justify-center">
      <button
        type="button"
        aria-label="Cerrar"
        onClick={onClose}
        className="absolute inset-0 bg-black/40 backdrop-blur-[2px]"
      />
      <div className="fr-sheet relative w-full max-w-[480px] rounded-t-4xl bg-background-50 pb-8 max-h-[88vh] overflow-y-auto no-scrollbar">
        <div className="sticky top-0 bg-background-50 pt-3 pb-2 px-5">
          <div className="mx-auto mb-3 h-1.5 w-10 rounded-full bg-background-300" />
          {title ? (
            <div className="flex items-center justify-between">
              <h2 className="text-lg font-semibold text-foreground-950">{title}</h2>
              <button
                type="button"
                onClick={onClose}
                className="w-8 h-8 flex items-center justify-center rounded-full bg-background-200 text-foreground-600"
              >
                <i className="ri-close-line text-lg" />
              </button>
            </div>
          ) : null}
        </div>
        <div className="px-5 pt-2">{children}</div>
      </div>
    </div>
  );
}